export const ThemeExtension = {
    status: {
        default: {
            color: 'rgba(33, 39, 46, .8)',
            backgroundColor: '#F1F1F1',
        },
        error: {
            color: '#FFF',
            backgroundColor: '#F94264',
        },
        primary: {
            color: '#FFF',
            backgroundColor: '#2196F3',
        },
        success: {
            color: '#FFF',
            backgroundColor: '#7ED321',
        },
        warning: {
            color: '#FFF',
            backgroundColor: '#FF660F',
        },
        info: {
            color: '#FFF',
            backgroundColor: '#2196F3',
        },
    },
    general: {
        pageContentSpacing: '62px',
        colors: {
            activitySidebarBackground: '#F7F7F8',
        },
        tableGutter: {
            outer: '24px',
            inner: '13px',
        },
    },
    stepper: {
        height: '72px',
        progressBarSize: '120px',
    },
    searchField: {
        borderRadius: '24px',
        minWidth: '230px',
        paddingLeft: 18,
        paddingBlock: 9,
        fontSize: 13,
    },
    tableFooter: {
        borderTop: '1px solid #6F7377',
        background: 'inherit',
        paddingBlock: 2,
        paddingInline: 3,
        fontSize: 13,
        controlHeight: 35,
    },
    button: {
        minHeight: 38,
        borderRadius: 4,
        fontSize: 13,
    },
    chip: {
        height: '1.5rem',
        borderRadius: '24px',
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: '0.5px',
        labelMinWidth: 120,
        listTextTransform: 'uppercase' as const,
        listTextAlign: 'center' as const,
        listWidth: '100%' as const,
    },
    modal: {
        paperBorderRadius: '4px',
        paperBoxShadow:
            '0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)',
        titleAlign: 'center' as const,
        titlePadding: '35px 0',
        titleFontSize: '20px',
        titleFontWeight: 400,
        titleBorderBottom: 'none',
        closeSize: '2.5rem',
        closeColor: '#1565D8',
        closeOffset: '12px',
        messageAlign: 'center' as const,
        messageFontSize: 15,
        messageLineHeight: '22px',
        contentPadding: '20px 24px',
        actionsPadding: '24px 88px',
        actionsBorderTop: 'none',
        actionTextTransform: 'uppercase' as const,
        actionFontWeight: 600,
        actionLetterSpacing: '0.5px',
    },
    toolbar: {
        height: '48px',
        color: '#FFFFFF',
        disabledColor: '#7DC7D4',
        hoverBackgroundColor: '#6DBFCF',
    },
    sidebar: {
        logoWidthOpen: 81,
        logoWidthCollapsed: 40,
        widthOpen: 248,
        widthCollapsed: 50,
        iconSize: 20,
        subheaderSize: 13,
        linkItemSize: 14,
        palette: {
            background: '#23282F',
            subheader: '#4A4F55',
            divider: '#46494F',
            text: '#989898',
            activeLink: '#fff',
        },
    },
    scrollbars: {
        color: '#2C93F0',
        backgroundColor: '#D5DFEB',
        backgroundColorDark: '#171B21',
        borderRadius: 2.5,
        width: 5,
    },
};
